// @flow
import thunk from 'redux-thunk';
import type {TGetState} from 'app/reducers';
import {makeStore} from 'app/store/make-store';
import {rootReducer} from 'app/reducers';

const isProd = 'production' === process.env.NODE_ENV;

function getAppStore({extraArgs} = {}) {
    const middlewares = [thunk.withExtraArgument(extraArgs)];

    return makeStore({
        debug: !isProd,
        middlewares,
        reducer: rootReducer,
    });
}

type TExtraArgs = typeof extraArgs;
type TPromiseAction = Promise<Object>;
type TThunkAction = (dispatch: TDispatch, getState: TGetState, extraArgs: TExtraArgs) => any;
type TDispatch = (action: Object | TThunkAction | TPromiseAction | Array<Object>) => any;

export {getAppStore};
export type {TDispatch, TExtraArgs, TThunkAction, TPromiseAction};
